export const UPDATE_WEBHOOK = 'update_webhook';
export const ADD_WEBHOOK = 'add_webhook';
export const REMOVE_WEBHOOK = 'remove_webhook';
export const UPDATE_SYSLOG_SERVER = 'update_syslog';
export const ADD_SYSLOG_SERVER = 'add_syslog';
export const REMOVE_SYSLOG_SERVER = 'remove_syslog';
export const UPDATE_EMAIL = 'update_email';
export const ADD_EMAIL = 'add_email';
export const REMOVE_EMAIL = 'remove_email';
export const UPDATE_INTEGRATIONS_EVENT_CONF = 'update_integrations_event_conf';
